<div class="compare-grid">
  <div>
    <h3>Keys only in {{env}}</h3>
    <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: keysExclusiveToCurrentEnv }"></ng-container>
  </div>
  <div>
    <h3>Keys only in {{envToCompare}}</h3>
    <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: keysExclusiveToComparedEnv }"></ng-container>
  </div>
</div>

<ng-template #recursiveList let-items>
  <ng-container *ngFor="let item of items">
    <div class="item" [style.paddingLeft.px]="(item.level || 0) * 10">
      <span class="marker" *ngIf="item.level">└─</span>
      <span>{{item.key}}</span>
    </div>
    <ng-container *ngIf="item.values?.length">
      <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item.values }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>
